export enum OauthProvider {
    Google = 'google',
}
